module.exports = __webpack_public_path__ + "static/media/financeNew.088dc5ac.svg";